import { ChangeStartDateRequestType } from 'src/components/common/Modal/СhangeDate';
import { CampaignProfile } from 'src/models/Account/CampaignProfile';
import { APIExportStartReturnType } from 'src/models/BaseApi';
import { CampaignPageSettingsType } from 'src/models/Campaigns';
import {
  MyCampaignCopyResponseType,
  MyCampaignCopyType,
  MyCampaignLoadCopyResponseType,
  MyCampaignsListFilterType,
  MyCampaignsListItemType,
} from 'src/models/Campaigns/MyCampaigns';
import { CommonTableResponseType } from 'src/models/Table';
import {
  ApiFunctionNoParamType,
  ApiFunctionType,
  httpGetCancellable,
  httpPost,
  httpPostCancellable,
} from 'src/utils/http';

const getPath = (path: string) => `/account/organizer/organizerCampaign/${path}`;

/** info for campaign page */
export const apiGetCampaignPageSettings: ApiFunctionNoParamType<CampaignPageSettingsType> = httpGetCancellable(
  getPath('pageSettings')
);

/** get organizer campaign list */
export const apiOrganizerGetCampaignList: ApiFunctionType<
  MyCampaignsListFilterType,
  CommonTableResponseType<MyCampaignsListItemType>
> = httpPostCancellable(getPath('listCampaigns'));

export const apiMyCampaignExport = (): Promise<APIExportStartReturnType> => httpPost(getPath('campaignscsv'));

export const apiGetCampaignProfile: ApiFunctionType<{ ID: number }, CampaignProfile> = httpPostCancellable(
  getPath('campaignProfile')
);

/** copy */
export const apiOrganizerValidateCopyCampaign = (model: MyCampaignCopyType): Promise<MyCampaignCopyResponseType> =>
  httpPost(getPath('validatecopycampaign'), model);

export const apiOrganizerCopyCampaign = (model: MyCampaignCopyType): Promise<MyCampaignCopyResponseType> =>
  httpPost(getPath('copycampaign'), model);

export const apiLoadCopyCampaignModal: ApiFunctionType<{ PermanentUrl: string }, MyCampaignLoadCopyResponseType> =
  httpPostCancellable(getPath('LoadCopyCampaignModal'));
/** copy end */

/** turn on/off a campaign */
export const apiChangeDonationAbility = (data: {
  PermanentUrl: string;
  IsDonationAllowed: boolean;
}): Promise<unknown> => httpPost(getPath('changedonationability'), data);

export const apiOrganizerEditStartSellingDate: ApiFunctionType<ChangeStartDateRequestType, ChangeStartDateRequestType> =
  httpPostCancellable(getPath('editstartsellingdate'));
